
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/[step2]",
      function () {
        return require("private-next-pages/checkout/[step2].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/[step2]"])
      });
    }
  